































































































































































































































































































































import Vue from 'vue';
import SaveData from '@/classes/saveData/saveData';
import Convert, { OldShipStockJson } from '@/classes/convert';
import SiteSetting from '@/classes/siteSetting';
import ItemStock from '@/classes/item/itemStock';
import ShipMaster from '@/classes/fleet/shipMaster';
import ReleaseNoteManager, { ReleaseNote } from '@/classes/releaseNote';
import ReleaseNoteList from '@/components/common/ReleaseNoteList.vue';

/** ホーム画面に並べるリリース数 */
const HOME_RELEASE_COUNT = 5;

export default Vue.extend({
  name: 'TopPage',
  components: {
    ReleaseNoteList,
  },
  mounted() {
    const saveData = this.$store.state.saveData as SaveData;
    saveData.disabledMain();
    this.loadReleases();
  },
  data: () => ({
    releases: [] as ReleaseNote[],
    releasesLoading: true,
    created: false,
    imported: false,
    importConfirmDialog: false,
    importFileName: '引き継ぎデータ',
    confirmDialog: false,
    importedStock: false,
    mainPages: [
      {
        title: 'Home.制空権シミュレータ',
        icon: 'mdi-calculator',
        color: 'green',
        text: [
          'Home.本サイトの主要機能です。',
          'Home.基地航空隊や艦隊、敵艦隊を編成することで、道中を含めた全ての戦闘の制空状態や艦載機の損耗、全滅率などのシミュレーションが可能です。',
        ],
        url: 'aircalc',
      },
      {
        title: 'Home.艦娘 / 装備管理',
        icon: 'mdi-database-cog',
        color: 'blue',
        text: [
          'Home.サブの機能です。',
          'Home.自分のゲーム内の艦娘、装備情報を登録すると、シミュレータ内で選択できる艦娘や装備に反映され、あの装備持ってた…？と悩む心配がなくなります。',
        ],
        url: 'manager',
      },
      {
        title: 'Home.みんなの編成',
        icon: 'mdi-human-greeting-variant',
        color: 'orange',
        text: ['Home.他の人がアップロードした編成データを閲覧できます。'],
        url: 'list',
      },
      {
        title: 'Common.サイト設定',
        icon: 'mdi-cog',
        color: 'grey',
        url: 'setting',
      },
    ],
    extraPages: [
      {
        title: 'Extra.艦娘性能一覧',
        icon: 'mdi-account-switch',
        color: 'green',
        text: 'Extra.艦娘の基本ステータスの確認と比較を行えます。',
        url: 'extra',
      },
      {
        title: 'Extra.装備性能一覧',
        icon: 'mdi-compare-horizontal',
        color: 'teal',
        text: 'Extra.装備の基本ステータスの確認と比較を行えます。',
        url: 'extra#items',
      },
      {
        title: 'Extra.対潜値計算機',
        icon: 'mdi-finance',
        color: 'light-blue',
        text: 'Extra.艦娘と装備から、指定した対潜値と必要なLvを計算します。',
        url: 'extra#asw-calculator',
      },
      {
        title: 'Extra.戦果砲管理',
        icon: 'mdi-progress-check',
        color: 'orange',
        text: 'Extra.戦果に関係する任務の進捗を管理する機能です。',
        url: 'extra#quest',
      },
      {
        title: 'Extra.敵艦生息地検索',
        icon: 'mdi-map-search',
        color: 'red',
        text: 'Extra.指定した敵艦が登場する海域を検索します。データが更新されていない場合もあるので、あくまで参考程度に。',
        url: 'extra#habitat',
      },
      {
        title: 'Extra.敵対空おばけ',
        icon: 'mdi-fire-alert',
        color: 'pink',
        text: 'Extra.敵艦の対空砲火ランキングです。見かけたら気を付けるか覚悟しましょう。',
        url: 'extra#aa-ranking',
      },
    ],
  }),
  computed: {
    isNameEmpty(): boolean {
      return this.importFileName.length <= 0;
    },
    needTrans(): boolean {
      return this.$i18n.locale !== 'ja';
    },
  },
  methods: {
    async loadReleases() {
      const releases = await ReleaseNoteManager.fetchReleases(this.$store.state.siteVersion);
      this.releases = releases.slice(0, HOME_RELEASE_COUNT);
      this.releasesLoading = false;
    },
    clickedButton(page: { url: string; clicked: boolean }) {
      if (page.clicked) return;
      switch (page.url) {
        case 'aircalc':
          page.clicked = true;
          this.goAirCalcPage();
          break;
        case 'setting':
          this.$emit('showSiteSetting');
          break;
        default:
          page.clicked = true;
          this.$router.push(page.url);
          break;
      }
    },
    goAirCalcPage() {
      const saveData = this.$store.state.saveData as SaveData;
      saveData.disabledMain();

      // ルートに無題のデータを生成
      const data = new SaveData();
      data.name = saveData.getNewSaveDataName();
      if (this.needTrans) {
        data.name = data.name.replace('新規データ', `${this.$t('SaveData.新規データ')} `);
      }
      data.isActive = true;
      data.isMain = true;
      saveData.childItems.push(data);
      this.$store.dispatch('updateSaveData', saveData);
      this.$store.dispatch('setMainSaveData', data);
      this.$router.push('aircalc');
    },
    checkOldData() {
      // 過去データが存在するかチェック
      const storage = window.localStorage;
      if (!storage) {
        this.$emit('inform', '旧編成データが見つかりませんでした。', true);
        this.imported = true;
        return;
      }

      const presets = storage.getItem('presets');
      const presetJSON = presets ? JSON.parse(presets) : undefined;
      if (!presetJSON || !presetJSON.length) {
        this.$emit('inform', '旧編成データが見つかりませんでした。', true);
        this.imported = true;
        return;
      }

      if (this.needTrans) {
        this.importFileName = `${this.$t('SaveData.引き継ぎデータ')}`;
      }
      this.imported = false;
      this.importConfirmDialog = true;
    },
    checkOldStockData() {
      this.importedStock = true;

      // 過去データが存在するかチェック
      const storage = window.localStorage;
      if (!storage) {
        this.$emit('inform', '所持装備 / 艦娘データが見つかりませんでした。', true);
        return;
      }

      const shipStocks = storage.getItem('shipStock');
      const itemStocks = storage.getItem('planeStock');
      const shipStocksJSON = shipStocks ? JSON.parse(shipStocks) : undefined;
      const itemStocksJSON = itemStocks ? JSON.parse(itemStocks) : undefined;
      if ((!shipStocksJSON || !shipStocksJSON.length) && (!itemStocksJSON || !itemStocksJSON.length)) {
        this.$emit('inform', '所持装備 / 艦娘データが見つかりませんでした。', true);
        return;
      }

      const hasCurrentStock = !!this.$store.state.shipStock.length || !!this.$store.state.itemStock.length;
      if (hasCurrentStock) {
        // 既にデータがあるならダイアログ
        this.confirmDialog = true;
        this.importedStock = false;
      } else {
        this.importOldStockData();
      }
    },
    importOldStockData() {
      this.importedStock = true;

      // 過去データが存在するかチェック
      const storage = window.localStorage;
      if (!storage) {
        this.$emit('inform', '所持装備 / 艦娘データが見つかりませんでした。', true);
        return;
      }

      const shipStocks = storage.getItem('shipStock');
      const itemStocks = storage.getItem('planeStock');
      const shipStocksJSON = shipStocks ? JSON.parse(shipStocks) : undefined;
      const itemStocksJSON = itemStocks ? JSON.parse(itemStocks) : undefined;
      if ((!shipStocksJSON || !shipStocksJSON.length) && (!itemStocksJSON || !itemStocksJSON.length)) {
        this.$emit('inform', '所持装備 / 艦娘データが見つかりませんでした。', true);
        return;
      }

      try {
        const setting = this.$store.state.siteSetting as SiteSetting;
        let restoreResult = false;
        if (shipStocksJSON && shipStocksJSON.length) {
          // 在籍艦娘情報変換 & 上書き
          const newStocks = Convert.restoreShipStock(shipStocksJSON as OldShipStockJson[], this.$store.state.ships as ShipMaster[]);
          if (newStocks.length) {
            restoreResult = true;
            // 設定書き換え
            setting.isStockOnlyForShipList = true;
            this.$store.dispatch('updateShipStock', newStocks);
          }
        }

        if (itemStocksJSON && itemStocksJSON.length) {
          // 所持装備情報変換 & 上書き
          const newStocks = Convert.restoreItemStock(itemStocksJSON as ItemStock[]);
          if (newStocks.length) {
            restoreResult = true;
            // 設定書き換え
            setting.isStockOnlyForItemList = true;
            this.$store.dispatch('updateItemStock', newStocks);
          }
        }

        this.$store.dispatch('updateSetting', setting);

        if (!restoreResult) {
          this.$emit('inform', 'データを読み込みましたが、引き継ぎ可能な編成データがありませんでした。', true);
          return;
        }

        this.$emit('inform', '所持装備 / 艦娘データの引き継ぎが完了しました。');
      } catch (error) {
        this.$emit('inform', 'データ引継ぎに失敗しました。', true);
        console.error(error);
      }
      this.confirmDialog = false;
    },
    importOldData() {
      this.imported = true;
      // 旧データ引継ぎ
      const storage = window.localStorage;
      try {
        const presets = storage.getItem('presets');
        const presetJSON = presets ? JSON.parse(presets) : undefined;
        if (!presetJSON || !presetJSON.length) {
          return;
        }

        const setting = storage.getItem('setting');
        const settingJSON = setting ? JSON.parse(setting) : undefined;
        const converter = new Convert(this.$store.state.items, this.$store.state.ships, this.$store.state.defaultEnemies);
        const oldData = converter.convertOldSimulatorToSaveData(presetJSON, settingJSON);

        if (oldData && oldData.childItems.length) {
          oldData.name = this.importFileName ? this.importFileName : '引き継ぎデータ';
          // セーブデータルート取得
          const saveData = this.$store.state.saveData as SaveData;
          const root = saveData.childItems.find((v) => v.isDirectory);
          if (root) {
            root.childItems.push(oldData);
            root.sortChild();
            this.$store.dispatch('updateSaveData', saveData);

            // 旧データ取り込み完了通知
            this.$emit('inform', '編成データの引き継ぎが完了しました。');
            this.$emit('openSidebar');
          }
        } else {
          this.$emit('inform', 'データを読み込みましたが、引き継ぎ可能な編成データがありませんでした。', true);
        }
      } catch (error) {
        this.$emit('inform', 'データ引継ぎに失敗しました。', true);
        console.error(error);
      }

      this.importConfirmDialog = false;
    },
    createBackUp() {
      this.created = true;
      this.$emit('downloadBackupFile');
    },
  },
});
